import type { ParsedWordSegmentWithDirection, WordRun } from '../types';

/**
 * Phase 5: Run Grouping
 *
 * Group consecutive words with same direction into directional runs.
 * Each run has direction, embedding level, and word list.
 */
export const groupWordsIntoRuns = (
  resolvedWords: Array<ParsedWordSegmentWithDirection>,
): Array<WordRun> => {
  const runs: Array<WordRun> = [];
  let currentRun: WordRun | null = null;

  for (const word of resolvedWords) {
    if (
      !currentRun ||
      currentRun.direction !== word.direction ||
      currentRun.embeddingLevel !== word.embeddingLevel
    ) {
      currentRun = {
        direction: word.direction,
        embeddingLevel: word.embeddingLevel,
        words: [],
        start: word.start,
        end: word.end,
      };
      runs.push(currentRun);
    }

    currentRun.words.push(word);
    currentRun.end = word.end;
  }

  return runs;
};
